import { RequestProductsActionPayloadData } from '../../redux/products';
import { BrowseServiceProductsData } from './types';

export const transformBrowseServiceProductsToReduxActionPayload = (
  browseServiceProductsData: BrowseServiceProductsData,
): RequestProductsActionPayloadData => {
  const {
    attributionToken,
    category,
    currencyCode,
    products: items,
    perPage,
    currentPage,
    totalPages,
    filters,
    totalProducts,
    productsReturnedCount,
    queryType,
    sortingOptions,
    navigation,
    partner,
    zeroExactResults,
    pinnedResultCount,
  } = browseServiceProductsData;

  return {
    category,
    currencyCode,
    items: { [currentPage]: items },
    perPage,
    filters,
    currentPage,
    totalPages,
    totalProducts,
    productsReturnedCount,
    queryType,
    sortingOptions,
    navigation,
    partner,
    providerAttributionToken: attributionToken || null,
    zeroExactResults,
    pinnedResultCount,
  };
};
